'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'الخدمة غير متوفرة في الوقت الحالي، من فضلك أعد المحاولة لاحقًأ',
    NEED_ACTIVE: 'حسابك {{account}} يستخدم هذا الموقع الإلكتروني للمرة الأولى، من فضلك  {{activeLink}} لاستكمال التفعيل والعودة إلى هذه الصفحة لإكمال العمليات',
    GOTO_ACTIVE: 'فعّل الآن',
    NOT_ACTIVED: 'لم يتم تفعيل هذا الحساب بنجاح، من فضلك {{activeLink}} لاستكمال هذا التفعيل',
    COMPLETE_ACTIVE: 'تأكيد التفعيل',
    FORBID_ACTIVE: 'هذا الحساب غير مدعم على AliExpress!',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: 'من فضلك سجّل الدخول بحساب آخر',
    ACTIVE_PAGE: 'زيارة صفحة تفعيل الحساب'
};